// Shared projects data used across portfolio and detail pages
export const projects = [
  {
    id: 1,
    title: 'DULLES TECHNOLOGY CORRIDOR DATA CENTER',
    category: ['commercial'],
    location: 'Ashburn, VA',
    value: '125.0M',
    size: '500,000 sq ft',
    completed: '2024',
    description:
      '500,000 sq ft hyperscale data center facility with 50MW power capacity. Features include redundant power systems, advanced cooling infrastructure, and Tier III+ certification. Project represents our largest completed project to date and showcases capabilities in mission-critical construction.',
    services: ['Architecture', 'Structural Engineering'],
    status: 'Completed',
    client: 'TechCorp Global',
    heroImage:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'TYSONS CORNER CORPORATE CAMPUS',
    category: ['commercial'],
    location: 'Tysons, VA',
    value: '95.3M',
    size: '300,000 sq ft',
    completed: '2024',
    description:
      '300,000 sq ft corporate headquarters campus for Fortune 500 technology company. Features include advanced data center infrastructure, collaborative workspaces, employee amenities, and sustainable design earning LEED Platinum certification. Project delivered 2 months ahead of schedule.',
    services: ['Architecture', 'Construction Management'],
    status: 'Completed',
    client: 'Fortune 500 Client',
    heroImage:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'ROCKVILLE SCIENCE & TECHNOLOGY PARK',
    category: ['commercial'],
    location: 'Rockville, MD',
    value: '86.9M',
    size: '250,000 sq ft',
    completed: '2023',
    description:
      '250,000 sq ft laboratory and research facility for biotech companies. Specialized construction including BSL-2 labs, clean rooms, vivarium, and advanced HVAC systems. Project required extensive coordination with regulatory agencies and specialized subcontractors.',
    services: ['Architecture', 'MEP Engineering'],
    status: 'Completed',
    client: 'Life Sciences Partner',
    heroImage:
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 4,
    title: "CAPITOL HILL LUXURY RESIDENTIAL COMMUNITY",
    category: ['residential'],
    location: 'Washington, DC',
    value: '67.5M',
    size: '200 units',
    completed: '2022',
    description:
      '200-unit luxury condominium development with premium finishes, rooftop amenities, fitness center, and secure parking. Project features smart home technology, energy-efficient systems, and high-end architectural details. All units sold within 6 months of completion.',
    services: ['Architecture', 'Interior Design'],
    status: 'Completed',
    client: 'Private Client',
    heroImage:
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 6,
    title: 'NATIONAL HARBOR ENTERTAINMENT DISTRICT',
    category: ['mixed-use'],
    location: 'Oxon Hill, MD',
    value: '63.5M',
    size: 'Multi-venue',
    completed: '2022',
    description:
      'Multi-venue entertainment complex including restaurants, retail spaces, movie theater, and event venues. Features waterfront boardwalk, outdoor performance spaces, and integrated parking structure. Project attracted over visitors in first year.',
    services: ['Architecture', 'Construction Management'],
    status: 'Completed',
    client: 'Harbor Partners',
    heroImage:
      'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 5,
    title: 'ALEXANDRIA WATERFRONT RESIDENTIAL TOWER',
    category: ['residential'],
    location: 'Alexandria, VA',
    value: '72.4M',
    size: '28 stories',
    completed: '2023',
    description:
      '28-story luxury residential tower with 250 units offering panoramic Potomac River views. Amenities include concierge services, rooftop pool, fitness center, private marina access, and ground-floor retail. Complex foundation work required due to waterfront location.',
    services: ['Architecture', 'Structural Engineering'],
    status: 'Completed',
    client: 'Waterfront Living',
    heroImage:
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&q=80&w=2070',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 7,
    title: 'SILVER SPRING TRANSIT-ORIENTED DEVELOPMENT',
    category: ['mixed-use'],
    location: 'Silver Spring, MD',
    value: '58.7M',
    size: '180 units',
    completed: '2022',
    description:
      '180-unit affordable housing development with ground-floor retail adjacent to Metro station. Project included community spaces, bike storage, and sustainable design features. Developed in partnership with Montgomery County Housing Opportunities Commission.',
    services: ['Architecture', 'Community Planning'],
    status: 'Completed',
    client: 'Metro Community',
    heroImage:
      'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 8,
    title: 'MCLEAN CORPORATE CENTER',
    category: ['commercial'],
    location: 'McLean, VA',
    value: '55.9M',
    size: '220,000 sq ft',
    completed: '2020',
    description:
      '220,000 sq ft corporate office building with executive suites, conference facilities, and fitness center. Building features advanced technology infrastructure, secure access systems, and premium finishes. Achieved LEED Gold certification and serves as headquarters for multiple companies.',
    services: ['Architecture', 'Project Management'],
    status: 'Completed',
    client: 'Corporate Client',
    heroImage:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 9,
    title: 'BETHESDA MEDICAL CENTER EXPANSION',
    category: ['healthcare'],
    location: 'Bethesda, MD',
    value: '52.8M',
    size: '85,000 sq ft',
    completed: '2023',
    description:
      '85,000 sq ft medical facility expansion including new surgical suites, diagnostic imaging center, and patient care wings. Specialized construction methods ensured infection control and maintained hospital operations throughout construction. Features state-of-the-art medical equipment infrastructure.',
    services: ['Architecture', 'Healthcare Planning'],
    status: 'Completed',
    client: 'Regional Health Network',
    heroImage:
      'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 10,
    title: "PRINCE GEORGE'S PLAZA MIXED-USE DEVELOPMENT",
    category: ['mixed-use'],
    location: 'Hyattsville, MD',
    value: '47.6M',
    size: '160 units',
    completed: '2021',
    description:
      'Transit-oriented development featuring 160 residential units, 40,000 sq ft of retail space, and structured parking. Located steps from Metro station, promoting sustainable urban living. Project achieved Enterprise Green Communities certification.',
    services: ['Architecture', 'Construction Management'],
    status: 'Completed',
    client: 'City Development Group',
    heroImage:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&q=80&w=2070",
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 11,
    title: 'ARLINGTON HEIGHTS MIXED-USE DEVELOPMENT',
    category: ['mixed-use'],
    location: 'Arlington, VA',
    value: '45.5M',
    size: '150,000 sq ft',
    completed: '2023',
    description:
      '150,000 sq ft development featuring 120 luxury apartments, 25,000 sq ft retail space, and underground parking for 200 vehicles. LEED Gold certified with sustainable features including solar panels, green roof systems, and energy-efficient HVAC systems.',
    services: ['Architecture', 'Sustainability Consulting'],
    status: 'Completed',
    client: 'Green Living Partners',
    heroImage:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 12,
    title: 'RESTON TOWN CENTER OFFICE COMPLEX',
    category: ['commercial'],
    location: 'Reston, VA',
    value: '41.2M',
    size: '175,000 sq ft',
    completed: '2021',
    description:
      '175,000 sq ft Class A office building with structured parking and landscaped plaza. Features include high-efficiency building systems, outdoor terraces, conference center, and café. Building achieved 98% occupancy within first year of completion.',
    services: ['Architecture', 'Structural Engineering'],
    status: 'Completed',
    client: 'RTC Partners',
    heroImage:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 13,
    title: 'PENTAGON CITY OFFICE TOWER RENOVATION',
    category: ['commercial'],
    location: 'Arlington, VA',
    value: '38.2M',
    size: '12 stories',
    completed: '2024',
    description:
      'Complete interior renovation of 12-story Class A office building including new mechanical systems, elevator modernization, lobby redesign, and tenant build-outs. Project completed while building remained occupied, requiring sophisticated phasing and logistics management.',
    services: ['Architecture', 'Interior Design'],
    status: 'Completed',
    client: 'Corporate Owner',
    heroImage:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 14,
    title: 'GEORGETOWN UNIVERSITY STUDENT HOUSING',
    category: ['education'],
    location: 'Washington, DC',
    value: '34.8M',
    size: '400 beds',
    completed: '2020',
    description:
      '400-bed student housing facility featuring suite-style apartments, study lounges, fitness center, and retail space. Building design integrates with historic Georgetown campus architecture while providing modern amenities. Project completed during summer break to minimize campus disruption.',
    services: ['Architecture', 'Structural Engineering'],
    status: 'Completed',
    client: 'Georgetown University',
    heroImage:
      'https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=2070&q=80',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 100,
    title: 'TM International Construction - Virginia',
    category: ['Commercial & Residential'],
    location: 'Virginia, USA',
    value: '100K - 45M',
    size: '300+ Projects',
    completed: 'Ongoing',
    description:
      'Our flagship Virginia operation provides comprehensive construction services for residential and commercial clients across the Commonwealth. With full state licensure and certification, we deliver quality workmanship across all construction disciplines including new construction, renovations, remodeling, and infrastructure development. This division has completed over 300 projects with values ranging in million.',
    services: ['New Construction', 'Renovation'],
    status: 'Active',
    client: 'Various Private/Commercial',
    heroImage:
      'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop',
  },
  {
    id: 101,
    title: 'TM International Construction - Washington DC',
    category: ['Government & Federal'],
    location: 'Washington DC',
    value: '5M - 35M',
    size: 'Various Locations',
    completed: '2024',
    description:
      'Specializing in federal and government projects, our DC division brings expertise in navigating complex regulatory requirements while delivering exceptional results for government facilities, office buildings, and commercial properties. We maintain security clearances and have established relationships with key government agencies and prime contractors. Our DC portfolio includes projects valued, real-life experiences etc.',
    services: ['Government Facilities', 'Security'],
    status: 'In Progress',
    client: 'Federal Government',
    heroImage:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop',
  },
  {
    id: 102,
    title: 'TM International Construction - Maryland',
    category: ['Sustainable Development'],
    location: 'Maryland, USA',
    value: '25M+',
    size: 'Green Building Projects',
    completed: '2023',
    description:
      'Our Maryland Sustainable Development Division focuses on environmentally responsible construction practices, green building certifications (LEED), and energy-efficient solutions for residential and commercial clients. We specialize in sustainable retrofits, net-zero energy buildings, and developments that minimize environmental impact while maximizing long-term value.',
    services: ['LEED Certification', 'Retrofits'],
    status: 'Completed',
    client: 'Eco-Developers',
    heroImage:
      'https://images.unsplash.com/photo-1518780664697-55e3ad937233?q=80&w=1965&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1518780664697-55e3ad937233?q=80&w=1965&auto=format&fit=crop',
  },
  {
    id: 103,
    title: 'TM International Real Estate',
    category: ['Property Development'],
    location: 'Multiple Markets',
    value: 'Various',
    size: 'Mixed-Use',
    completed: 'Ongoing',
    description:
      'Providing investment and consulting services, our Delaware entity focuses on strategic partnerships, project financing, and business development opportunities in the construction sector. This division manages our investment portfolio, identifies acquisition targets, and provides strategic advisory services to construction companies seeking growth capital or operational improvements.',
    services: ['Acquisitions', 'Asset Management'],
    status: 'Active',
    client: 'Investors / Partners',
    heroImage:
      'https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=2070&auto=format&fit=crop',
  },
  {
    id: 104,
    title: 'TM International Real Estate',
    category: ['Property Development'],
    location: 'Multiple Markets',
    value: 'Various',
    size: 'Mixed-Use',
    completed: 'Ongoing',
    description:
      'Our real estate division specializes in property development, investment opportunities, and asset management. We identify and develop high-value properties that generate strong returns for our investors through strategic acquisitions, value-add improvements, and professional property management. Our real estate portfolio includes residential developments, mixed-use projects, and commercial properties across multiple markets.',
    services: ['Acquisitions', 'Asset Management'],
    status: 'Active',
    client: 'Investors / Partners',
    heroImage:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop',
  },
  {
    id: 105,
    title: 'AskMYteam.com',
    category: ['Digital Platform'],
    location: 'Global / Online',
    value: '50M+ Facilitated',
    size: 'Online Platform',
    completed: 'Live',
    description:
      'Our innovative digital platform connects homeowners and businesses with qualified construction professionals through advanced matching algorithms and comprehensive vetting processes. This technology-driven solution streamlines the contractor selection process, provides transparent pricing, and ensures quality service delivery through customer reviews and performance monitoring. The platform has facilitated over $50 million in construction projects since launch.',
    services: ['Contractor Matching', 'Vetting'],
    status: 'Live Platform',
    client: 'Homeowners/Businesses',
    heroImage:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop',
    gallery: [
      'https://st.hzcdn.com/simgs/62013ac205c1994a_14-1115/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a613c3605b54cb1_16-0467/home-design.jpg',
      'https://st.hzcdn.com/simgs/1e017cad052c214d_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/2a21553a05b55a20_16-3906/home-design.jpg',
      'https://st.hzcdn.com/simgs/2dd144de052c2192_14-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/2fc13e5e05b54ed4_9-1013/home-design.jpg',
      'https://st.hzcdn.com/simgs/3f51176f052c217d_16-6183/home-design.jpg',
      'https://st.hzcdn.com/simgs/5ad17c2d05b54cc0_16-0481/home-design.jpg',
      'https://st.hzcdn.com/simgs/5c1163a3061acfa8_16-3130/home-design.jpg',
      'https://st.hzcdn.com/simgs/6bc1678404cedd4a_14-4259/home-design.jpg',
      'https://st.hzcdn.com/simgs/6cc1c8c2052c216f_14-6282/home-design.jpg',
      'https://st.hzcdn.com/simgs/7bb145f9077e183d_16-6991/kitchen-2fliving.jpg',
      'https://st.hzcdn.com/simgs/7cf1d072077e1ab9_16-7629/landscape.jpg',
      'https://st.hzcdn.com/simgs/8a91a892061dbbb1_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/8eb150df077e18a5_16-7115/roof.jpg',
      'https://st.hzcdn.com/simgs/8fc16bac05b54ec4_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/9a91ef0605b54ebc_16-0993/home-design.jpg',
      'https://st.hzcdn.com/simgs/9bd1b76804cedd41_16-4232/home-design.jpg',
      'https://st.hzcdn.com/simgs/9ce1ec2f077e17d3_16-6888/bathroom.jpg',
      'https://st.hzcdn.com/simgs/45b1703505b5557a_16-2719/tm-20international-20construction-20designs.jpg',
      'https://st.hzcdn.com/simgs/56d1f533052c2155_16-6226/home-design.jpg',
      'https://st.hzcdn.com/simgs/67d180db05b55a06_16-5886/beach-20house-20projects-20-2f-20designs.jpg',
      'https://st.hzcdn.com/simgs/75f11cff05b54cbb_16-0479/home-design.jpg',
      'https://st.hzcdn.com/simgs/1591f220061acfb2_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/2661cd84077e1a7f_14-7569/section-image.jpg',
      'https://st.hzcdn.com/simgs/5021b97b05b54ec7_16-1000/home-design.jpg',
      'https://st.hzcdn.com/simgs/8381b124052c2172_16-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/048190e7061dbbb7_16-8527/home-design.jpg',
      'https://st.hzcdn.com/simgs/72416e4e061dbbc1_16-4669/home-design.jpg',
      'https://st.hzcdn.com/simgs/97612b99061acfaa_16-5369/home-design.jpg',
      'https://st.hzcdn.com/simgs/137112b004cedd18_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/8091540e05b54cbd_16-0480/home-design.jpg',
      'https://st.hzcdn.com/simgs/1381280304cedd0d_14-8673/home-design.jpg',
      'https://st.hzcdn.com/simgs/5711470305b559ff_16-3873/home-design.jpg',
      'https://st.hzcdn.com/simgs/53815340061acfab_16-5350/home-design.jpg',
      'https://st.hzcdn.com/simgs/a8b1bc8804cedd53_16-8680/home-design.jpg',
      'https://st.hzcdn.com/simgs/a871b91c061acfb6_16-5453/home-design.jpg',
      'https://st.hzcdn.com/simgs/b6b19775061dbbb5_16-8051/home-design.jpg',
      'https://st.hzcdn.com/simgs/b2213cb305b54ed0_16-1009/home-design.jpg',
      'https://st.hzcdn.com/simgs/b751685b052c2157_9-0936/home-design.jpg',
      'https://st.hzcdn.com/simgs/ba21a068061acfbd_16-5452/home-design.jpg',
      'https://st.hzcdn.com/simgs/be71838905c19945_14-1347/home-design.jpg',
      'https://st.hzcdn.com/simgs/bfe1ed8b052c2181_14-6168/home-design.jpg',
      'https://st.hzcdn.com/simgs/c8717eed05b559fc_16-3872/home-design.jpg',
      'https://st.hzcdn.com/simgs/cd21179b05b55574_16-2713/home-design.jpg',
      'https://st.hzcdn.com/simgs/d171136805b54eca_16-1006/home-design.jpg',
      'https://st.hzcdn.com/simgs/dab1ef21077e1889_16-7114/basement.jpg',
      'https://st.hzcdn.com/simgs/dae10931061acfc1_16-5398/home-design.jpg',
      'https://st.hzcdn.com/simgs/dfc10792061dbbb9_16-8155/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6b1f26a052c216c_14-1001/home-design.jpg',
      'https://st.hzcdn.com/simgs/e6c1cd74077e1763_16-6776/kitchen.jpg',
      'https://st.hzcdn.com/simgs/e45116ae04cedd25_14-4341/home-design.jpg',
      'https://st.hzcdn.com/simgs/f7a15987052c2179_16-6281/home-design.jpg',
    ],
    image:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop',
  },
];

export const getProjectById = (id) => projects.find((p) => p.id === Number(id));

